import { render, staticRenderFns } from "./RESTAll.vue?vue&type=template&id=b8f0d3a0"
import script from "./RESTAll.vue?vue&type=script&lang=js"
export * from "./RESTAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports